export function getClientOrder(client_orderId) {
    let { getClientOrderRequest, getClientOrderError, getClientOrderResult } = this.props

    this.doAction(this.WEB_REQUEST_URL + 'get_client_order', this.createBundle('get_client_order', { client_orderId }, this.GET, getClientOrderRequest, getClientOrderResult, getClientOrderError))
}
